import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseIcon = _resolveComponent("BaseIcon")!

  return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.to ? 'router-link' : 'a'), { to: _ctx.to }, {
    default: _withCtx(({ route }) => [
      _createElementVNode("div", {
        class: _normalizeClass([[
        _ctx.isRouteActive(route.path)
          ? 'text-dark-500 border-primary-500'
          : 'text-gray-400 border-transparent group-hover:text-gray-900 group-hover:border-gray-400 group-focus:text-gray-900 group-focus:border-gray-400'
      ], "flex items-center font-semibold border-b-2 mx-5 focus:outline-none group h-full"])
      }, [
        (_ctx.icon)
          ? (_openBlock(), _createBlock(_component_BaseIcon, {
              key: 0,
              name: _ctx.icon,
              class: "mr-2"
            }, null, 8, ["name"]))
          : _createCommentVNode("", true),
        _renderSlot(_ctx.$slots, "default")
      ], 2)
    ]),
    _: 3
  }, 8, ["to"]))
}